export default __webpack_public_path__ + "static/media/nature-logo.981b9b36.png";